import { twMerge } from 'tailwind-merge';

import { clsx, type ClassValue } from 'clsx';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function displayVariantTitle(title: string | null | undefined) {
  const trimmedTitle = title?.trim();
  return trimmedTitle && trimmedTitle.toLowerCase() !== 'default title' ? trimmedTitle : null;
}
